import { createApp } from 'vue';
import { createStore } from 'vuex';
import Posts from './views/Posts.vue';

// Create a new store instance.
if (document.getElementById('posts')) {
    const store = createStore({
        state() {
            return {
                postType: document.getElementById('posts').getAttribute('data-post-type'),
                postPerPage: document.getElementById('posts').getAttribute('data-post-per-page'),
                shownCategory: document.getElementById('posts').getAttribute('data-shown-category'),
                Trigger: 0,
                Filters: [],
                filtersInitialLoad: false,
                allFiltersSetFromUrl: false,
                filterState: false,
                resetAllFilters: false,
                initialPageLoad: true,
                loading: true,
                page: 1,
                matchPost: null
            }
        },
        mutations: {
            fetchFilterData(state, payload) {
                //
                //
                // Fetch setted filter from FilterBlock component.
                state.Filters.forEach((filterItem, index) => {
                    if (filterItem.tax == payload.tax) {
                        filterItem.values = payload.values;
                    }
                });
                // console.log('Show state filters', JSON.parse(JSON.stringify(state.Filters)))
            },
            initializeFiltersState(state, payload) {
                //
                //
                // Initialize Filters from dom element data attribute
                let filters = [];
                payload.forEach((item, index) => {
                    let filterItem = {
                        tax_name: item.label,
                        tax: item.value,
                        values: []
                    };
                    filters.push(filterItem);
                });
            if (filters.length > 0) {
                state.Filters = filters;
            }
                state.filtersInitialLoad = true;
                // console.log('filtersInitialLoad', state.filtersInitialLoad);
            },
            triggerCount(state) {
                state.Trigger++;
                //console.log('Trigger', state.Trigger);
            },
            setFilterState(state) {
                let activeFilterCount = 0;
                state.Filters.forEach((filterItem, index) => {
                    activeFilterCount += filterItem.values.length;
                });
            if (activeFilterCount !== 0) {
                state.filterState = true;
            } else {
                state.filterState = false;
            }
                // console.log(state.Filters);
            },
            setFilterFromTermObject(state, payload) {
                // Used to set filter from url params
                let filterObject = {
                    name: payload.name,
                    slug: payload.slug,
                    id: payload.term_id
                };

                state.Filters.forEach((filterItem, index) => {
                    if (filterItem.tax == payload.taxonomy) {
                        state.Filters[index].values.push(filterObject);
                    }
                });
            },
            resetFilters(state) {
                state.Filters.forEach((filterItem, index) => {
                    state.Filters[index].values = [];
                });
                state.resetAllFilters = true;
                state.filterState = false;

                let checkboxes = document.getElementsByClassName('checkbox-input');
            for (let checkbox of checkboxes) {
                checkbox.checked = false;
            }

                // console.log(state.Filters);

                // Reset addressbar
                let fullUrl = window.location.origin;
                fullUrl += /inspiraties/;

                window.history.pushState(fullUrl, "Inspiratie", fullUrl);

                // TODO: Reset actieve filters bug -> FilterBlockCheckGroup 'value' array must be empty after reset
            }
        },
        getters: {
            filterTrigger(state) {
                console.log('filterTrigger');
                return state.Trigger;
            }
        }
    });

    const app = createApp(Posts);
    app.use(store);
    app.mount('#posts');
}
